import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import "./Blog.css";

const AllCommentsPage = () => {
  const { slug } = useParams();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loading state
  const [error, setError] = useState(null);     // ✅ error state
const url=process.env.REACT_APP_LINK
  useEffect(() => {
    const fetchComments = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${url}/api/comments/slug/${slug}`);
        const data = await res.json();

        if (!Array.isArray(data)) {
          throw new Error("Invalid response format");
        }

        setComments(data);
      } catch (err) {
        console.error("❌ Error fetching all comments:", err);
        setError("Failed to load comments.");
      } finally {
        setLoading(false);
      }
    };

    if (slug) fetchComments();
  }, [slug]);

  return (
    <div className="blog-comment-hbt-all-wrapper">
      <h2 className="blog-comment-hbt-title">
        <MessageCircle size={16} style={{ marginRight: "6px" }} />
        All Comments ({comments.length})
      </h2>

      {loading && <p>Loading comments...</p>}
      {error && <p className="error-text">{error}</p>}

      <ul className="blog-comment-hbt-list">
        {comments.map((comment, index) => (
          <li key={index} className="blog-comment-hbt-comment">
            <strong className="blog-comment-hbt-author">
              {comment.author || "Anonymous"}
            </strong>
            <span className="blog-comment-hbt-date">
              {new Date(comment.createdAt).toLocaleString()}
            </span>
            <p className="blog-comment-hbt-content">{comment.content}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AllCommentsPage;
